/** @jsxImportSource @emotion/react */
import { colors, TextItalic, YoutubeButton } from 'components/landing/ui';

import bg1x from '../../images/s3-bg-1x.png';
import bg2x from '../../images/s3-bg-2x.png';
import bg3x from '../../images/s3-bg-3x.png';

const RightCol = ({ openVideo }) => (
  <div>
    <div css={{ position: 'relative', alignItems: 'flex-start' }}>
      <img srcSet={`${bg1x} 1x, ${bg2x} 2x, ${bg3x} 3x`} css={{ width: '100%' }} />

      <YoutubeButton
        css={{
          position: 'absolute',
          left: 'calc(50% - 64px/2)',
          top: 'calc(34% - 46px/2)',
        }}
        onClick={() => openVideo('how')}
      />

      <TextItalic
        css={{ position: 'absolute', color: colors.grayLight, maxWidth: '60%', top: '77%' }}
      >
        “Настройки привлечения внимания в VK-BOSS”
      </TextItalic>
    </div>
  </div>
);

export default RightCol;
